import type { ComponentType } from 'react';

/**
 * Web variant — react-native-pdf is native-only (its Fabric component
 * import breaks the web bundle outright), so web callers always get
 * null here and use PdfThumb.web.tsx / the iframe preview instead.
 */
export interface NativePdfProps {
  source: { uri: string; cache?: boolean };
  style?: object;
  singlePage?: boolean;
  page?: number;
  onError?: (error: object) => void;
  trustAllCerts?: boolean;
}

export function getNativePdf(): ComponentType<NativePdfProps> | null {
  return null;
}
